import React, { useState, useEffect, useCallback, useRef } from 'react'
import {
    CSpinner,
    CButton,
    CRow,
    CCol,
    CCard,
    CCardBody,
    CCardHeader,
    CModal,
    CModalBody,
    CModalFooter,
    CModalHeader,
    CModalTitle,
    CBadge
  } from '@coreui/react'
import {
    CChartDoughnut,
} from '@coreui/react-chartjs'
import { useSelector, useDispatch } from 'react-redux';
import InfoBox from '../../components/infobox/InfoBox';
import { TileLayer, Marker, Popup, MapContainer, GeoJSON, useMap, LayersControl, LayerGroup, FeatureGroup, Circle, Rectangle } from 'react-leaflet'
import ReactLeafletKml from 'react-leaflet-kml';
import L from 'leaflet'
import omnivore, { geojson } from '@mapbox/leaflet-omnivore'
import retinaIcon from '../../assets/icons/marker-icon-2x.png';
import icon from '../../assets/icons/marker-icon.png';
import iconShadow from '../../assets/icons/marker-shadow.png';
import { activeMap } from '../../apollo/cache';
import history from '../../history'
import { useQuery } from '@apollo/client';
import { GET_ONE_FEDERAL_ELECTION_MAP, GET_ONE_FEDERAL_POLL_MAP } from '../../apollo/queries';
import html2canvas from 'html2canvas';
import ReactGA from 'react-ga';
// import Fullscreen from 'react-leaflet-fullscreen-plugin';
import { SET_SHOW_INFOBOX, SET_VIEW_ADJUST } from '../../redux/actions';
import { provinceShortToLong } from '../../helpers/Utils';

var screenshotkeypress = 0;
let fired = false;
var geojsonlayer;
var politicalParties, leadershipRounds;

var oneMap = ["1"];

let DefaultIcon = L.icon({
    iconRetinaUrl: retinaIcon,
    iconUrl: icon,
    iconAnchor: new L.Point(16, 16),
    shadowUrl: iconShadow
});

const zoomOptions = {
  position: 'topleft',
  title: 'Show me the fullscreen !',
  titleCancel: 'Exit fullscreen mode',
  content: null,
  forceSeparateButton: true,
  forcePseudoFullscreen: true,
  fullscreenElement: false,
};

const getSortedKeys = (obj) => {
  var keys = Object.keys(obj);
  return keys.sort(function(a,b){return obj[b]-obj[a]});
}

function compare(a, b) {
  if (a.val > b.val) return -1;
  if (a.val < b.val) return 1;
  return 0;
}

const featureStyle = (feature) => {
  var mwid = feature.properties['pr'];
  if (feature.properties['mw'].match(/^[0-9]+[\-]{1}[0-9]+[A-Z]{1}$/g) || feature.properties['mw'].match(/^[0-9]+[A-Z]{1}$/g)) {
    mwid = feature.properties['pr'].substring(0,feature.properties['pr'].length-1);
  }
  return {
    className: "mw-"+mwid
  }
};

L.Marker.prototype.options.icon = DefaultIcon;

var mapObj = (activeMap());

//const position = mapObj.center;

const ReactLeaflet = (props) => {

    var dispatch = useDispatch();

    const gjl = useRef();
    const gjl1 = useRef();
    const gjl2 = useRef();
    const gjl_leadership = useRef();
    
    const darkMode = useSelector(state => state.starter.darkMode)
    const mapCount = useSelector(state => state.starter.mapCount)
    const showInfoBox = useSelector(state => state.starter.showInfoBox)
    const viewadjust = useSelector(state => state.starter.viewadjust)

    mapObj = props.data;
    activeMap(mapObj);

    var reOrderedBounds = [[0,0],[10,10]];

const doReOrder = (b) => {
  console.log(b);
  console.log([[b[0][0],b[0][1]],[b[1][0],b[1][1]]])
  return [[b[0][0],b[0][1]],[b[1][0],b[1][1]]];
}

    if (mapObj !== null) {
        reOrderedBounds = [[mapObj.bounds[0][1],mapObj.bounds[0][0]],[mapObj.bounds[1][1],mapObj.bounds[1][0]]];
    } else {
        reOrderedBounds = [[0,0],[10,10]]
    }

    let [overlayLayer, setoverlayLayer] = useState({});
    let [modalVisible, setModalVisible] = useState(false);
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    let [modalContent, setModalContent] = useState('');
    let [pollDetailsTitle, setPollDetailsTitle] = useState('');
    let [mw, setMW] = useState('');
    let [thePollYear, setThePollYear] = useState('');
    let [theElectionType, setTheElectionType] = useState('');
    let [theRidingNumber, setTheRidingNumber] = useState('');
    let [theRejectedNumber, setTheRejectedNumber] = useState('');
    let [theElectorsNumber, setTheElectorsNumber] = useState('');
    let [bounds, setbounds] = useState(L.latLngBounds(reOrderedBounds));
    let [theParties, setTheParties] = useState([]);
    let [theLeadershipRounds, setTheLeadershipRounds] = useState([]);
    let [theBoundsStatus, setTheBoundsStatus] = useState(0);
    let [theContent, setTheContent] = useState('');
    let [theRiding, setTheRiding] = useState([]);
    let [theScreenshot, setTheScreenshot] = useState(false);
    const [theMap, setTheMap] = useState(null);
    const [screenshotbuttondisable, setscreenshotbuttondisable] = useState(false);
    const [partyAdjustmentFactor, setPartyAdjustmentFactor] = useState([]);
    const [loading, setLoading] = useState(0);
    const mapContainerElement = useRef(null);
    const mapContainerRef = useRef(null);
    let [mapRendered, setMapRendered] = useState(false);

    function handleWindowSizeChange() {
      setScreenWidth(window.innerWidth);
    }
    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);
  
    const isMobile = screenWidth <= 768;

    const mapScreenshot = () => {
      ReactGA.event({
        category: "Map screenshot",
        action: "click",
        label: mapObj.geojson_url,
      });      
      const elements = mapContainerElement.current;
      html2canvas(elements, {useCORS:true}).then(canvas => {
        var pseudolink = document.createElement('a');
        pseudolink.download = mapObj.title+'.png';
        pseudolink.href = canvas.toDataURL()
        pseudolink.click();
        document.getElementById("mapScreenshotButton").removeAttribute("disabled");
        setTheScreenshot(false);
    }).catch(err => console.log(err) );
    }

    const sharetwitter = () => {
      var quote = "Check out the results of "+mapObj.district;
      quote = encodeURIComponent(quote);
      if (mapObj.event_type === "Provincial") {
        window.open("https://twitter.com/intent/tweet?url=https://www.stephentaylor.ca/data/political/canada/provincial/election/"+provinceShortToLong(mapObj.minor_jurisdiction).toLowerCase()+"/"+mapObj.year+"/"+mapObj.local_division+"/&text="+quote, "pop", "width=600, height=600, scrollbars=no");
      } else {
        window.open("https://twitter.com/intent/tweet?url=https://www.stephentaylor.ca/data/political/canada/federal/election/"+mapObj.year+"/"+mapObj.local_division+"/&text="+quote, "pop", "width=600, height=600, scrollbars=no");
      }
      return false;
    }
    
    const sharepinterest = () => {
      if (mapObj.event_type === "Provincial") {
        window.open("https://pinterest.com/pin/create/link/?url=https://www.stephentaylor.ca/data/political/canada/provincial/election/"+provinceShortToLong(mapObj.minor_jurisdiction).toLowerCase()+"/"+mapObj.year+"/"+mapObj.local_division+"/&media=https://geojson-maps.s3.amazonaws.com/images/"+mapObj.minor_jurisdiction+"-"+mapObj.year+"-"+mapObj.local_division+"-600.png&description="+mapObj.district, "pop", "width=600, height=600, scrollbars=no");
      } else {
        window.open("https://pinterest.com/pin/create/link/?url=https://www.stephentaylor.ca/data/political/canada/federal/election/"+mapObj.year+"/"+mapObj.local_division+"/&media=https://geojson-maps.s3.amazonaws.com/images/"+mapObj.year+"-"+mapObj.local_division+"-600.png&description="+mapObj.title, "pop", "width=600, height=600, scrollbars=no");
      }
    }

    document.addEventListener('keydown', function(event) {
      if (event.keyCode === 191) {
          setscreenshotbuttondisable(true);
          mapScreenshot();
        }
    });

    document.addEventListener('keyup', (e) => {
      fired = false;
    });

    const nationalFeatureLeadership = (feature, layer, p) => {
      if (feature.properties && feature.properties.Rounds) {
        if (feature.properties.Rounds[p].winner === "Erin O'Toole") {
          layer.setStyle({fillColor:'#7AB7F5', color:'#7AB7F5', weight:0.25})
        } else if (feature.properties.Rounds[p].winner === "Leslyn Lewis") {
           layer.setStyle({fillColor:'#8BF571', color:'#8BF571', weight:0.25})
        } else if (feature.properties.Rounds[p].winner === "Peter MacKay") {
           layer.setStyle({fillColor:'#b871f5', color:'#b871f5', weight:0.25})
        } else if (feature.properties.Rounds[p].winner === "Derek Sloan") {
           layer.setStyle({fillColor:'#F571D8', color:'#F571D8', weight:0.25})
        } else if (feature.properties.Rounds[p].winner === "Peter MacKay / Erin O'Toole") {
         layer.setStyle({fillColor:'#453FFF', color:'#453FFF', weight:0.25})
        } else if (feature.properties.Rounds[p].winner === "Leslyn Lewis / Erin O'Toole") {
          layer.setStyle({fillColor:'#19BF80', color:'#19BF80', weight:0.25})
        }
     }
      layer.on("mouseover", function(e){
        dispatch({type: SET_SHOW_INFOBOX, showInfobox: true})
        var infoboxContent = {}
        infoboxContent.properties = feature.properties;
        infoboxContent.rounds = true;
        infoboxContent.roundnum = p;
        setTheContent(infoboxContent);
        layer.setStyle({weight:1.0, fillOpacity:0.3});
      });
      layer.on("mouseout", function(e){
        layer.setStyle({weight:0.25, fillOpacity:0.2});
      });
    }

    const onEachNationalFeatureRiding = (feature, layer) => {
      if (feature.properties && (feature.properties.PARTY || feature.properties['Poll Winner'] || feature.properties['Winner'])) {
        if (feature.properties.PARTY === "Liberal" || feature.properties['Poll Winner'] === "Liberal" || feature.properties['Winner'] === "Liberal") {
          layer.setStyle({fillColor:'red', color:'#ff0000', weight:0.25})
        } else if (feature.properties.PARTY === "PC" || feature.properties['Poll Winner'] === "Progressive Conservative" || feature.properties['Poll Winner'] === "Conservative" || feature.properties['Winner'] === "Conservative" || feature.properties['Winner'] === "Progressive Conservative") {
          layer.setStyle({fillColor:'blue', color:'blue', weight:0.25})
        } else if (feature.properties.PARTY === "NDP" || feature.properties['Poll Winner'] === "N.D.P." || feature.properties['Poll Winner'] === "NDP-New Democratic Party" || feature.properties['Poll Winner'] === "NDP" || feature.properties['Winner'] === "NDP" || feature.properties['Winner'] === "N.D.P.") {
          layer.setStyle({fillColor:'orange', color:'#ff7200', weight:0.25})
        } else if (feature.properties.PARTY === 'Bloc Québécois' || feature.properties['Poll Winner'] === "Bloc Québécois" || feature.properties['Winner'] === "Bloc Québécois") {
          layer.setStyle({fillColor:'#0b9fd6', color:'#0b9fd6', weight:0.25})
        } else if (feature.properties.PARTY === 'Canadian Alliance' || feature.properties['Poll Winner'] === "Canadian Alliance" || feature.properties['Winner'] === "Canadian Alliance") {
          layer.setStyle({fillColor:'#5ba963', color:'#5ba963', weight:0.25})
        } else if (feature.properties.PARTY === 'Green Party' || feature.properties['Poll Winner'] === "Green Party" || feature.properties['Winner'] === "Green Party") {
          layer.setStyle({fillColor:'green', color:'green', weight:0.25})
        } else if (feature.properties.PARTY === "People's Party" || feature.properties['Poll Winner'] === "People's Party" || feature.properties['Winner'] === "People's Party" || feature.properties.PARTY === "People's Party - PPC" || feature.properties['Poll Winner'] === "People's Party - PPC" || feature.properties['Winner'] === "People's Party - PPC") {
          layer.setStyle({fillColor:'#7f0f7e', color:'#7f0f7e', weight:0.25})          
        } else if (feature.properties.PARTY === 'Independent' || feature.properties['Poll Winner'] === "Independent" || feature.properties['Winner'] === "Independent") {
          layer.setStyle({fillColor:'#424242', color:'#424242', weight:0.25})
        } else if (feature.properties.PARTY === 'null' || feature.properties['Poll Winner'] === "null") {
          layer.setStyle({fillColor:'#000000', color:'#000000', weight:0.25})
        }
      }
      layer.on("mouseover", function(e){
        dispatch({type: SET_SHOW_INFOBOX, showInfobox: true})
        setTheContent(feature.properties);
        layer.setStyle({weight:1.0, fillOpacity:0.3});
      });
      layer.on("click", function(e){
          if (mapObj.hasOwnProperty('district') && mapObj.event_type == 'Provincial') {
            history.push('/political/canada/provincial/election/'+mapObj.district.toLowerCase()+'/'+mapObj.year+'/'+e.target.feature.properties['Riding ID']);
          } else {
            history.push('/political/canada/federal/election/'+mapObj.year+'/'+e.target.feature.properties['Riding ID']);  
          }
      });
      layer.on("mouseout", function(e){
        layer.setStyle({weight:0.25, fillOpacity:0.2});
      });
    }
    
    const onEachFeaturePoll = (feature, layer) => {
      //var tabledata = '';
      var modaldata = '';
      var tablearray = [];
      var candidateArray = [];
      var candidateDisplayArray = [];
      var pdt = '';
      var pollElectors = 0;
      var pollTotalVotes = 0;
      var ridingName = '';
      var pollName = '';
      var pollID = '';
      var pollWinner = '';
      var pollYear = '';
      var electionType = '';
      var ridingNumber = '';
      var rejectedNumber = '';
      var electorsNumber = '';
      var mergeWith = null;
      for (var key in feature.properties) {
          if (feature.properties.hasOwnProperty(key)) {
            // if (key === "Electors") {
            //   pollElectors = feature.properties[key];
            // }            
            if (key !== "Candidates") {
              if (key === "Riding Name") {
                ridingName = feature.properties[key];
              } else if (key === "Poll name") {
                pollName = feature.properties[key];
              } else if (key === "pr") {
                // omit
              } else if (key === "Poll ID") {
                pollID = feature.properties[key];
              } else if (key === "Rejected Ballots") {
                rejectedNumber = feature.properties[key];                
              } else if (key === "Electors") {
                electorsNumber = feature.properties[key];                                
              } else if (key === "Poll Winner") {
                pollWinner = feature.properties[key];
              } else if (key === "Riding") {
                ridingNumber = feature.properties[key];                
              } else if (key === "mw") {
                mergeWith = feature.properties[key];
              } else if (key === "Election") {
                pollYear = feature.properties[key];
              } else if (key === "Election Type") {
                electionType = feature.properties[key];
              } 
              else {
                var tableObj = {};
                tableObj.name = key;
                tableObj.val = feature.properties[key]
                tablearray.push(tableObj);
              }              //tabledata += '<tr><td style="padding:5px;border:1px solid black;">'+key+'</td><td style="padding:5px;border:1px solid black;">'+feature.properties[key]+'</td></tr>'
            }
          }
      }
      pdt = ridingName + ' ('+pollID+' - ' + pollName+')';
      for (var key1 in feature.properties) {
        if (feature.properties.hasOwnProperty(key1)) {
            if (key1 === "Candidates") {
              for (var i=0;i<feature.properties[key1].length;i++) {
                var countObj = {};
                countObj.name = feature.properties[key1][i].name;
                countObj.party = feature.properties[key1][i].party;
                countObj.val = feature.properties[key1][i].votes;
                pollTotalVotes += feature.properties[key1][i].votes;                
                candidateArray.push(countObj);
              }
              for (i=0;i<candidateArray.length;i++) {
                if (pollTotalVotes > 0) { 
                  candidateArray[i].pc = (candidateArray[i].val / pollTotalVotes * 100).toFixed(1);
                } else {
                  candidateArray[i].pc = 0+"%";
                }
              }
              candidateArray.sort(compare);
              for (i=0;i<candidateArray.length;i++) {                                  
                var tableObj1 = {};
                tableObj1.name = candidateArray[i].name + (pollWinner === candidateArray[i].party && i === 0 ? ' ⭐' : '');
                tableObj1.party = candidateArray[i].party;
                tableObj1.val = candidateArray[i].val;
                tableObj1.pc = candidateArray[i].pc;
                candidateDisplayArray.push(tableObj1);
                //tabledata += '<tr><td style="padding:5px;border:1px solid black;">'+feature.properties[key][i].name+' ('+feature.properties[key][i].party+')</td><td style="padding:5px;border:1px solid black;">'+feature.properties[key][i].votes+' votes</td></tr>'  
              }
            }
        }
    }      
      //layer.bindPopup('<table style="width:500px;border:1px solid black;"><tr><th style="padding:5px;border:1px solid black;">Attribute</th><th style="padding:5px;border:1px solid black;">Value</th></tr>'+tabledata+'</table>',
      //{
        //maxWidth:500  
      //});

      layer.on('click', function() { 
        dispatch({type: SET_SHOW_INFOBOX, showInfobox: false});
        var mc = [];
        var candidateRows = candidateDisplayArray.map((item,ind) => 
        <CRow key={ind} className="border">
          <CCol style={ind%2 ? {fontSize:'10px'} : {backgroundColor:'#eaeaea',fontSize:'10px'}}>{item.name}</CCol>
          <CCol xs style={ind%2 ? {fontSize:'10px'} : {backgroundColor:'#eaeaea',fontSize:'10px'}}>{item.party}</CCol>
          <CCol className="col-2" style={ind%2 ? {fontSize:'10px'} : {backgroundColor:'#eaeaea',fontSize:'10px'}}>{item.val}</CCol>
          <CCol className="col-2" style={ind%2 ? {fontSize:'10px'} : {backgroundColor:'#eaeaea',fontSize:'10px'}}>{item.pc}</CCol>
        </CRow>
        )
        var candidateTable = (<div key={"candidate-table"} style={{margin:'0 auto',position:'relative',width:'90%'}}>
          <CRow className="border">
            <CCol xs style={{fontWeight:'500',fontSize:'10px'}}>Candidate</CCol>
            <CCol xs style={{fontWeight:'500',fontSize:'10px'}}>Party</CCol>
            <CCol className="col-2" style={{fontWeight:'500',fontSize:'10px'}}>Votes</CCol>
            <CCol className="col-2" style={{fontWeight:'500',fontSize:'10px'}}>%</CCol>
          </CRow>
          {candidateRows}
          </div>)

        var pollTableData = (<div key={"poll-table"} style={{margin:'0 auto',position:'relative',width:'90%',paddingTop:'10px'}}>
        <CRow>
          { electorsNumber != null ? <CCol xs style={{fontSize:'10px'}}><span role="img" aria-label="electors emoji">👥</span> Electors: {electorsNumber}</CCol> : <></> }          
        </CRow>
        <CRow>
        { rejectedNumber != null ? <CCol xs style={{fontSize:'10px'}}><span role="img" aria-label="rejected emoji">🙅‍♀️</span> Rejected ballots: {rejectedNumber}</CCol> : <></> }
        </CRow>
        </div>
        )
      mc.push(candidateTable);
      mc.push(pollTableData);
      setPollDetailsTitle(pdt);
      setMW(mergeWith);
      setThePollYear(pollYear);
      setTheElectionType(electionType);
      setTheRidingNumber(ridingNumber);
      setModalContent(mc); 
      setModalVisible(true); 
      });
      var defaultFill = layer.options.fillColor;
      layer.on("mouseover", function(e){
        dispatch({type: SET_SHOW_INFOBOX, showInfobox: true})
        setTheContent(feature.properties);
        layer.setStyle({weight:1.0, fillOpacity:0.3});
        if (feature.properties['mw'].length > 0) {
          var mwid = feature.properties['mw'];
          var mwid_original = feature.properties['mw'];
          if (feature.properties['mw'].match(/^[0-9]+[\-]{1}[0-9]+[A-Z]{1}$/g) || feature.properties['mw'].match(/^[0-9]+[A-Z]{1}$/g)) {
            mwid = feature.properties['mw'].substring(0,feature.properties['mw'].length-1);
          }
          var votes = 0;
          for (i=0;i<feature.properties['Candidates'].length;i++) {
            votes += feature.properties['Candidates'][i].votes;
          }
          if (votes === 0) {
            if (document.getElementsByClassName('mw-'+mwid).length > 0) {
                document.getElementsByClassName('mw-'+mwid)[0].style.fill="#424242";
            } else {
              try {
                document.getElementsByClassName('mw-'+mwid_original)[0].style.fill="#424242";
              } catch {}
            }
          }
        };
      });
      layer.on("mouseout", function(e){
        layer.setStyle({weight:0.25, fillOpacity:0.2});
        if (feature.properties['mw'] !== "") {
          var mwid = feature.properties['mw'];
          var mwid_original = feature.properties['mw'];
          if (feature.properties['mw'].match(/^[0-9]+[\-]{1}[0-9]+[A-Z]{1}$/g) || feature.properties['mw'].match(/^[0-9]+[A-Z]{1}$/g)) {
            mwid = feature.properties['mw'].substring(0,feature.properties['mw'].length-1);
          }
          var votes = 0;
          for (i=0;i<feature.properties['Candidates'].length;i++) {
            votes += feature.properties['Candidates'][i].votes;
          }          
          if (votes === 0) {
            if (document.getElementsByClassName('mw-'+mwid).length > 0) {
                document.getElementsByClassName('mw-'+mwid)[0].style.fill=defaultFill;
            } else {
              try {
                document.getElementsByClassName('mw-'+mwid_original)[0].style.fill=defaultFill;
              } catch {}
            }
          }
        };          
      });          
      if (feature.properties && (feature.properties.PARTY || feature.properties['Poll Winner'] || feature.properties['Winner'])) {
        if (feature.properties.PARTY === "Liberal" || feature.properties['Poll Winner'] === "Liberal" || feature.properties['Winner'] === "Liberal") {
          layer.setStyle({fillColor:'red', color:'#ff0000', weight:0.25})
        } else if (feature.properties.PARTY === "PC" || feature.properties['Poll Winner'] === "Progressive Conservative" || feature.properties['Poll Winner'] === "Conservative" || feature.properties['Winner'] === "Conservative" || feature.properties['Winner'] === "Progressive Conservative") {
          layer.setStyle({fillColor:'blue', color:'blue', weight:0.25})
        } else if (feature.properties.PARTY === "NDP" || feature.properties['Poll Winner'] === "N.D.P." || feature.properties['Poll Winner'] === "NDP-New Democratic Party" || feature.properties['Poll Winner'] === "NDP" || feature.properties['Winner'] === "NDP" || feature.properties['Winner'] === "N.D.P.") {
          layer.setStyle({fillColor:'orange', color:'#ff7200', weight:0.25})
        } else if (feature.properties.PARTY === 'Bloc Québécois' || feature.properties['Poll Winner'] === "Bloc Québécois" || feature.properties['Poll Winner'].startsWith("Bloc ") || feature.properties['Winner'] === "Bloc Québécois") {
          layer.setStyle({fillColor:'#0b9fd6', color:'#0b9fd6', weight:0.25})
        } else if (feature.properties.PARTY === 'Canadian Alliance' || feature.properties['Poll Winner'] === "Canadian Alliance" || feature.properties['Winner'] === "Canadian Alliance") {
          layer.setStyle({fillColor:'#5ba963', color:'#5ba963', weight:0.25})
        } else if (feature.properties.PARTY === 'Green Party' || feature.properties['Poll Winner'] === "Green Party" || feature.properties['Winner'] === "Green Party") {
          layer.setStyle({fillColor:'green', color:'green', weight:0.25})
        } else if (feature.properties.PARTY === "People's Party" || feature.properties['Poll Winner'] === "People's Party" || feature.properties['Winner'] === "People's Party"  || feature.properties.PARTY === "People's Party - PPC" || feature.properties['Poll Winner'] === "People's Party - PPC" || feature.properties['Winner'] === "People's Party - PPC") {
          layer.setStyle({fillColor:'#7f0f7e', color:'#7f0f7e', weight:0.25})             
        } else if (feature.properties.PARTY === 'Independent' || feature.properties['Poll Winner'] === "Independent" || feature.properties['Winner'] === "Independent") {
          layer.setStyle({fillColor:'#424242', color:'#424242', weight:0.25})
        } else if (feature.properties.PARTY === 'null' || feature.properties['Poll Winner'] === "null") {
          layer.setStyle({fillColor:'#000000', color:'#000000', weight:0.25})
        }
      }
    }

    const partyStrength = (feature, layer, party) => {
      var tabledata = '';
      var totalvotes = 0;
      var partyvotes = 0;
      var partypercent = 0;
      var maxpartyvotes = 0;
      var maxparty, minparty;
      var paj = 1;

      var tablearray = [];
      for (var key in feature.properties) {
          if (feature.properties.hasOwnProperty(key)) {
              if (key === "Candidates") {
                for (var i=0;i<feature.properties[key].length;i++) {
                  var tableObj = {};
                  tableObj.name = feature.properties[key][i].name+ ' ('+feature.properties[key][i].party+')';
                  tableObj.val = feature.properties[key][i].votes+ ' vote';
                  tableObj.val += feature.properties[key][i].votes > 1 ? 's': '';
                  tablearray.push(tableObj);
                  //tabledata += '<tr><td style="padding:5px;border:1px solid black;">'+feature.properties[key][i].name+' ('+feature.properties[key][i].party+')</td><td style="padding:5px;border:1px solid black;">'+feature.properties[key][i].votes+' votes</td></tr>'  
                }
              } else {
                var tableObj = {};
                tableObj.name = key;
                tableObj.val = feature.properties[key]
                tablearray.push(tableObj);
                //tabledata += '<tr><td style="padding:5px;border:1px solid black;">'+key+'</td><td style="padding:5px;border:1px solid black;">'+feature.properties[key]+'</td></tr>'
              }
          }
      }

      for (var key in feature.properties) {
          var poll = feature.properties['Poll ID'];
          if (feature.properties.hasOwnProperty(key)) {
              if (key === "Candidates") {
                partyvotes = 0;
                partypercent = 0;
                totalvotes = 0;
                for (var i=0;i<feature.properties[key].length;i++) {
                  totalvotes += feature.properties[key][i].votes;
                  if (feature.properties[key][i].party === party) {
                    partyvotes = feature.properties[key][i].votes;
                  }
                  //tabledata += '<tr><td style="padding:5px;border:1px solid black;">'+feature.properties[key][i].name+' ('+feature.properties[key][i].party+')</td><td style="padding:5px;border:1px solid black;">'+feature.properties[key][i].votes+' votes</td></tr>'  
                }
                if (totalvotes === 0) {
                  partypercent = 0;
                } else {
                  partypercent = partyvotes / totalvotes * 100 * partyAdjustmentFactor[party];
                }
              } else {
                //tabledata += '<tr><td style="padding:5px;border:1px solid black;">'+key+'</td><td style="padding:5px;border:1px solid black;">'+feature.properties[key]+'</td></tr>'
              }
          }
      }
      if (layer !== undefined) { 
        // layer.bindPopup('<table style="width:500px;border:1px solid black;"><tr><th style="padding:5px;border:1px solid black;">Attribute</th><th style="padding:5px;border:1px solid black;">Value</th></tr>'+tabledata+'</table>',
        // {
        //   maxWidth:500  
        // });
        layer.on('click', function() { dispatch({type: SET_SHOW_INFOBOX, showInfobox: false});
        setModalContent(tablearray.map((item,ind) => 
        <CRow key={ind}>
          <CCol xs style={{fontSize:'10px'}}>{item.name}</CCol>
          <CCol xs style={{fontSize:'10px'}}>{item.val}</CCol>
        </CRow>)); setModalVisible(true); });        
        var defaultFill = layer.options.fillColor;
        layer.on("mouseover", function(e){
          dispatch({type: SET_SHOW_INFOBOX, showInfobox: true})
          setTheContent(feature.properties);
          if (feature.properties['Poll Winner'] !== "null") {
            layer.setStyle({weight:1.0, fillOpacity:0.7});
          } else {
            layer.setStyle({weight:1.0, fillOpacity:0.3});
          }
          
          if (feature.properties['mw'] !== "") {
            var mwid = feature.properties['mw'];
            if (feature.properties['mw'].match(/^[0-9]+[\-]{1}[0-9]+[A-Z]{1}$/g) || feature.properties['mw'].match(/^[0-9]+[A-Z]{1}$/g)) {
              mwid = feature.properties['mw'].substring(0,feature.properties['mw'].length-1);
            }
            try {
              document.getElementsByClassName('mw-'+mwid)[0].style.fill="#424242";
            } catch {}
          };
        });
        layer.on("mouseout", function(e){
          if (feature.properties['mw'] !== "") {
            layer.setStyle({weight:0.25, fillOpacity:0.2});
          } else {
            layer.setStyle({weight:0.25, fillOpacity:0.5});
          }
          if (feature.properties['mw'] !== "") {
            var mwid = feature.properties['mw'];
            if (feature.properties['mw'].match(/^[0-9]+[\-]{1}[0-9]+[A-Z]{1}$/g) || feature.properties['mw'].match(/^[0-9]+[A-Z]{1}$/g)) {
              mwid = feature.properties['mw'].substring(0,feature.properties['mw'].length-1);
            }
            try {
            document.getElementsByClassName('mw-'+mwid)[0].style.fill=defaultFill;
            } catch {}
          };          
        });          
        if (feature.properties && (feature.properties.PARTY || feature.properties['Poll Winner']) !== "null") {
          if (feature.properties['mw'] !== '') {
            layer.setStyle({fillColor:'#000000', fillOpacity:0.2, color:'#000000', weight:0.25})
          } else {
            if (partypercent >= 70) {
              layer.setStyle({fillColor:'#57bb8a', fillOpacity:0.5, color:'#000000', weight:0.25})
            } else if (partypercent < 70 && partypercent >= 65) {
              layer.setStyle({fillColor:'#73b87e', fillOpacity:0.5, color:'#000000', weight:0.25})
            } else if (partypercent < 65  && partypercent >= 60) {
              layer.setStyle({fillColor:'#94bd77', fillOpacity:0.5, color:'#000000', weight:0.25})
            } else if (partypercent < 60  && partypercent >= 55) {
              layer.setStyle({fillColor:'#b0be6e', fillOpacity:0.5, color:'#000000', weight:0.25})
            } else if (partypercent < 55  && partypercent >= 50) {
              layer.setStyle({fillColor:'#d4c86a', fillOpacity:0.5, color:'#000000', weight:0.25})
            } else if (partypercent < 50  && partypercent >= 45) {
              layer.setStyle({fillColor:'#f5ce62', fillOpacity:0.5, color:'#000000', weight:0.25})
            } else if (partypercent < 45  && partypercent >= 40) {
              layer.setStyle({fillColor:'#e9b861', fillOpacity:0.5, color:'#000000', weight:0.25})
            } else if (partypercent < 40  && partypercent >= 35) {
              layer.setStyle({fillColor:'#ecac67', fillOpacity:0.5, color:'#000000', weight:0.25})
            } else if (partypercent < 35  && partypercent >= 30) {
              layer.setStyle({fillColor:'#e79a69', fillOpacity:0.5, color:'#000000', weight:0.25})
            } else if (partypercent < 30  && partypercent >= 25) {
              layer.setStyle({fillColor:'#e2886c', fillOpacity:0.5, color:'#000000', weight:0.25})
            } else if (partypercent < 25) {
              layer.setStyle({fillColor:'#dd776e', fillOpacity:0.5, color:'#000000', weight:0.25})
            } 
          }
      } else {
        layer.setStyle({fillColor:'#000000', fillOpacity:0.2, color:'#000000', weight:0.25})
      }    
      }
    }

    const ChangeView = ({bounds}) => {
      const map = useMap();
      console.log(gjl1)
      console.log(gjl2)
      console.log(!gjl1.current)
      if (mapContainerElement.current && (gjl1.current || gjl2.current || gjl_leadership.current || gjl.current)) {
        console.log("AAAAAAAAA");
      } else {
        console.log("BBBBBBBBB");
        map.fitBounds(bounds)
      }
      return null;
    }

    // const InfoCard = useMemo() => {
    //   return(
    //   <CCard>
    //     <CCardHeader>!!!!!</CCardHeader>
    //     <CCardBody>Hello</CCardBody>
    //   </CCard>
    //   );
    // }

    useEffect(() => {
      if (mapRendered) {
        if (mapObj === null) {
          setoverlayLayer(null);
          dispatch({type: SET_SHOW_INFOBOX, showInfobox: false})
          setTheBoundsStatus(0);
        fetch(
          "https://geojson-maps.s3.amazonaws.com/canada/federal/2000_lDzc0HfrgekPGgfjBFjd.geojson", { crossDomain:true }
        )
          .then((res) => res.text())
          .then((geojsontext) => { 
            var geojsonlayer = JSON.parse(geojsontext);
            setoverlayLayer(geojsonlayer)
            setbounds(L.latLngBounds(geojsonlayer.bbox));
            console.log("A");
            console.log(geojsonlayer.bbox)
            var politicalParties = [];
            var parties = geojsonlayer.features[0].properties.Candidates;
            for (var i=0;i<parties.length;i++) {
              politicalParties.push(parties[i].party);
            }
            //setTheRiding(["1"]);
            setTheParties(politicalParties);
            //activeMap(map);
            setTheBoundsStatus(1);
          }) 
        } else {
            setLoading(1);
            setoverlayLayer({});
            
            setTheBoundsStatus(0);
            console.log(mapObj);
            fetch(
                props.data.geojson_url, { crossDomain:true }
              )
                .then((res) => res.text())
                .then((geojsontext) => { 
                  var geojsonlayer = JSON.parse(geojsontext);
                  setbounds(L.latLngBounds(geojsonlayer.bbox));
                  if (gjl1.current) {
                    gjl1.current.clearLayers().addData(geojsonlayer);
                  }
                  if (gjl2.current) {
                    gjl2.current.clearLayers().addData(geojsonlayer);
                  }                  
                  if (gjl_leadership.current) {
                    gjl_leadership.current.clearLayers().addData(geojsonlayer);
                  }
                  setoverlayLayer(geojsonlayer)
                  console.log("B");
                  console.log(geojsonlayer.bbox)                  

                  if (mapObj.event === 'Election') {
                    politicalParties = [];
                    var parties = geojsonlayer.features[0].properties.Candidates;
                    for (var i=0;i<parties.length;i++) {
                      politicalParties.push(parties[i].party);
                    }

                    var partyvotes = [];
                    var partyStrengthAdjustmentFactor = [];
                    var maxPartyVoteinAPoll;
                    var ridingtotalvotes = 0;
                    var paf = [];
                  
                    // create the party vote array
                    for (var i=0;i<geojsonlayer.features[0].properties['Candidates'].length;i++) {
                      partyvotes[geojsonlayer.features[0].properties['Candidates'][i].party] = 0;
                      paf[geojsonlayer.features[0].properties['Candidates'][i].party] = 0;
                    }

                    for (var j=0; j<geojsonlayer.features.length; j++) {
                      if (geojsonlayer.features[j].properties.hasOwnProperty('Candidates')) {
                        for (var i=0;i<geojsonlayer.features[j].properties['Candidates'].length;i++) {
                          partyvotes[geojsonlayer.features[j].properties['Candidates'][i].party] = partyvotes[geojsonlayer.features[j].properties['Candidates'][i].party] + geojsonlayer.features[j].properties['Candidates'][i].votes;
                          ridingtotalvotes += geojsonlayer.features[j].properties['Candidates'][i].votes;
                        }          
                      }      
                    }
                    var sortedParty;
                    sortedParty = getSortedKeys(partyvotes);
                    console.log(partyvotes);
                    console.log(sortedParty);
                    for (var i=0;i<geojsonlayer.features[0].properties['Candidates'].length;i++) {
                      paf[geojsonlayer.features[0].properties['Candidates'][i].party] = paf[geojsonlayer.features[0].properties['Candidates'][i].party] + (0.5 / ( partyvotes[geojsonlayer.features[0].properties['Candidates'][i].party] / ridingtotalvotes ));
                    }

                    setPartyAdjustmentFactor(paf);
                    setTheParties([]);
                    setTheParties(sortedParty);
                  }

                  if (mapObj.event === 'Leadership') {
                    leadershipRounds = [];
                    var rounds = geojsonlayer.features[0].properties.Rounds;
                    for (var i=0;i<rounds.length;i++) {
                      leadershipRounds.push(i);
                    }

                    setTheLeadershipRounds([]);
                    setTheLeadershipRounds(leadershipRounds);
                  }
  
                  //activeMap(map);
                  setTheRiding(["1"]);
                  dispatch({type: SET_SHOW_INFOBOX, showInfobox: false})
                  setTheBoundsStatus(1);
                  setLoading(0);                  

                })
        }
      }
      

        if (!mapRendered ) {
          setMapRendered(true);
        }

      }, [dispatch, mapRendered, props.data.local_division, props.data.geojson_url, darkMode]);
      
      var tiles = "Esri";
      var data_attr = mapObj.event_type === 'Provincial' && provinceShortToLong(mapObj.minor_jurisdiction).toLowerCase() === 'ontario' ? '<a href="https://elections.on.ca">Elections Ontario</a>' : '<a href="https://elections.ca">Elections Canada</a>';
      if (mapObj.minor_jurisdiction === 'conservative') {
        data_attr = '<a href="https://conservative.ca">Conservative Party</a>';
      }
      var attribution = '&copy; <a href="https://stephentaylor.ca">Stephen Taylor</a>; Tiles: &copy; '+tiles+', Data: '+data_attr;

    return (
      <div>
<CModal size="lg" show={modalVisible} onClose={() => setModalVisible(false)}>
      <CModalHeader onClose={() => setModalVisible(false)}>
        <CModalTitle>{pollDetailsTitle}</CModalTitle>
        {mw.length > 0 ? <CBadge className="mr-1 float-right" color="secondary">merge with: {mw}</CBadge> : ""}
      </CModalHeader>
      <CModalBody>{modalContent}</CModalBody>
      <CModalFooter>
        <div style={{fontSize:'8px',fontWeight:'200',position:'absolute',left:'10px'}}>{thePollYear != null ? thePollYear+' ' : ''} {theElectionType === 'Provincial' && props.hasOwnProperty('data') && props.data.hasOwnProperty('minor_jurisdiction') ? provinceShortToLong(props.data.minor_jurisdiction) : ''} {theElectionType != null ? theElectionType+' ' : ''} {theRidingNumber != null ? '- '+theRidingNumber+' ' : ''}</div>
        <CButton color="secondary" onClick={() => setModalVisible(false)}>
          Close
        </CButton>
      </CModalFooter>
    </CModal>        
      <CRow className="align-items-center" style={{marginBottom:'10px'}}>
        <CCol col="12" sm="12" md="12" xl className="mb-3 mb-xl-0">
          <CButton id="mapScreenshotButton" color="light" onClick={() => { setTheScreenshot(true); mapScreenshot(); }}>{!theScreenshot ? "📷" : "📸"} {!theScreenshot ? "Download" : "Downloading..."}</CButton>
          {typeof props.data.local_division === 'undefined' ? <></> : 
            <>
              <CButton id="sharetwitter" style={{marginLeft:'5px'}} color="info" onClick={() => { sharetwitter(); }}> <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" className="c-icon mfe-2" role="img"><path d="M31.937 6.093c-1.177 0.516-2.437 0.871-3.765 1.032 1.355-0.813 2.391-2.099 2.885-3.631-1.271 0.74-2.677 1.276-4.172 1.579-1.192-1.276-2.896-2.079-4.787-2.079-3.625 0-6.563 2.937-6.563 6.557 0 0.521 0.063 1.021 0.172 1.495-5.453-0.255-10.287-2.875-13.52-6.833-0.568 0.964-0.891 2.084-0.891 3.303 0 2.281 1.161 4.281 2.916 5.457-1.073-0.031-2.083-0.328-2.968-0.817v0.079c0 3.181 2.26 5.833 5.26 6.437-0.547 0.145-1.131 0.229-1.724 0.229-0.421 0-0.823-0.041-1.224-0.115 0.844 2.604 3.26 4.5 6.14 4.557-2.239 1.755-5.077 2.801-8.135 2.801-0.521 0-1.041-0.025-1.563-0.088 2.917 1.86 6.36 2.948 10.079 2.948 12.067 0 18.661-9.995 18.661-18.651 0-0.276 0-0.557-0.021-0.839 1.287-0.917 2.401-2.079 3.281-3.396z"></path></svg> Share</CButton>
              <CButton id="sharepinterest" style={{marginLeft:'5px'}} color="danger" onClick={() => { sharepinterest(); }}><svg height="100%" className="c-icon" viewBox="0 0 512 512" width="100%" xmlns="http://www.w3.org/2000/svg"><path d="M255.998,0.001c-141.384,0 -255.998,114.617 -255.998,255.998c0,108.456 67.475,201.171 162.707,238.471c-2.24,-20.255 -4.261,-51.405 0.889,-73.518c4.65,-19.978 30.018,-127.248 30.018,-127.248c0,0 -7.659,-15.334 -7.659,-38.008c0,-35.596 20.632,-62.171 46.323,-62.171c21.839,0 32.391,16.399 32.391,36.061c0,21.966 -13.984,54.803 -21.203,85.235c-6.03,25.482 12.779,46.261 37.909,46.261c45.503,0 80.477,-47.976 80.477,-117.229c0,-61.293 -44.045,-104.149 -106.932,-104.149c-72.841,0 -115.597,54.634 -115.597,111.095c0,22.004 8.475,45.596 19.052,58.421c2.09,2.535 2.398,4.758 1.776,7.343c-1.945,8.087 -6.262,25.474 -7.111,29.032c-1.117,4.686 -3.711,5.681 -8.561,3.424c-31.974,-14.884 -51.963,-61.627 -51.963,-99.174c0,-80.755 58.672,-154.915 169.148,-154.915c88.806,0 157.821,63.279 157.821,147.85c0,88.229 -55.629,159.232 -132.842,159.232c-25.94,0 -50.328,-13.476 -58.674,-29.394c0,0 -12.838,48.878 -15.95,60.856c-5.782,22.237 -21.382,50.109 -31.818,67.11c23.955,7.417 49.409,11.416 75.797,11.416c141.389,0 256.003,-114.612 256.003,-256.001c0,-141.381 -114.614,-255.998 -256.003,-255.998Z"></path></svg></CButton>          
            </>
          }
        </CCol>
      </CRow>
      <div ref={mapContainerElement}>
      <MapContainer key={mapCount+3300000} center={[0,0]} zoom={5} preferCanvas={true} scrollWheelZoom={true} whenCreated={setTheMap} style={{height:'80vh', background:'transparent'}}>
        <LayersControl key={mapCount+4400000} position="topright" collapsed={isMobile ? true : false}>
        {loading === 0 ? <div key={mapCount+5500000}>
        { typeof props.data.minor_jurisdiction !== 'undefined' && props.data.event === 'Leadership' && gjl_leadership !== null && theLeadershipRounds ? theLeadershipRounds.map((p, i) => ( 
          <LayersControl.BaseLayer key={mapCount+6600000+i} checked={ i===0 ? true : false } name={"Round "+(p+1)+ " winner"}>
            <LayerGroup key={mapCount+33100000}>
              <GeoJSON ref={gjl_leadership} key={mapCount+33200000} data={overlayLayer} onEachFeature={(feature, layer) => {nationalFeatureLeadership(feature, layer, p)}} />
            </LayerGroup>
          </LayersControl.BaseLayer>
        )) : <></> }
        { typeof props.data.local_division === 'undefined' && gjl !== null && props.data.event !== 'Leadership' && theRiding ? theRiding.map((p, i) => ( 
          <LayersControl.BaseLayer key={mapCount+33300000} checked name="Riding winner">
            <LayerGroup key={mapCount+33400000}>
              <GeoJSON ref={gjl} key={mapCount+33500000} data={overlayLayer} onEachFeature={onEachNationalFeatureRiding} />
            </LayerGroup>
          </LayersControl.BaseLayer>
        )) : <></> }
        </div> : <></> }
        {loading === 0 ? <div key={mapCount+100000}>
        { typeof props.data.local_division !== 'undefined' && gjl !== null && theRiding ? theRiding.map((p, i) => (
            <LayersControl.BaseLayer key={mapCount+190090900} checked name="Poll winner">
            <LayerGroup>
              <GeoJSON ref={gjl1} key={mapCount+2000} style={featureStyle} data={overlayLayer} onEachFeature={onEachFeaturePoll} />
            </LayerGroup>
          </LayersControl.BaseLayer>
        )) : <></> }  
        </div> : <></> }
        {loading === 0 ? <div key={mapCount+200000}>
          { typeof props.data.local_division !== 'undefined' && theParties ? theParties.map((p, i) => (
          <LayersControl.BaseLayer key={"a"+i+mapCount+3000} name={mapObj.winner === p ? p +" strength ☑️" : p + " strength"}>
            <LayerGroup>
              <GeoJSON ref={gjl2} key={mapCount+1000} style={featureStyle} data={overlayLayer} onEachFeature={(feature, layer) => {partyStrength(feature, layer, p)}} />
            </LayerGroup>
          </LayersControl.BaseLayer>
          )) : <></> }
        </div> : <></> }
        </LayersControl>     
        <ChangeView bounds={bounds}/>
        {loading === 1 ? <div style={{width:'100%', height:'100%', display:'flex', justifyContent: 'center', alignItems: 'center'}}>
        <CSpinner
        color="primary"
        style={{width:'4rem', height:'4rem', margin:'0 auto', position:'relative', display: 'block'}}
        />
        </div> : <></> }
        {loading === 0 ? <TileLayer
          attribution={attribution}
          url={darkMode ? "https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Dark_Gray_Base/MapServer/tile/{z}/{y}/{x}" : "https://server.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}" }
        />        
        : <></> }
        {/* <Fullscreen
          eventHandlers={{
            enterFullscreen: (event) => console.log('entered fullscreen', event),
            exitFullscreen: (event) => console.log('exited fullscreen', event),
          }}
          {...zoomOptions}
        />         */}
      {(theContent !== '' && showInfoBox) ? <InfoBox {...theContent} /> : <></>}
      </MapContainer></div></div>
    )
  }
  
  export default ReactLeaflet